module.exports = __webpack_public_path__ + "static/media/pre-page-2021.21f2e646.png";